import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { HYDRATE, type HydrateAction } from "@/redux/reducers/hydration";
type ConfigState = {
  domainCountryCode: string;
};
export const initialState: ConfigState = { domainCountryCode: "US" };
const configSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action: HydrateAction) => {
      /**
       * The `config` state is modified in `getServerSideProps`
       * and needs to be loaded here to ensure that data is added to the
       * redux state.
       */
      return {
        /**
         * Retain any state that was added client-side that isn't in the initial state.
         */
        ...state,
        ...action.payload.config,
      };
    });
  },
  initialState,
  name: "config",
  reducers: {
    setDomainCountryCode: (state, action: PayloadAction<string>) => {
      state.domainCountryCode = action.payload;
    },
  },
});
export const { setDomainCountryCode } = configSlice.actions;
export default configSlice.reducer;
